import { render } from "./OrderCard.vue?vue&type=template&id=589ab911&scoped=true"
import script from "./OrderCard.vue?vue&type=script&lang=js"
export * from "./OrderCard.vue?vue&type=script&lang=js"

import "./OrderCard.vue?vue&type=style&index=0&id=589ab911&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tom/tom/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589ab911"]])

export default __exports__